const QuestionType = {
  GET_QUESTION_LIST: "GET_QUESTION_LIST",
  GET_C0DE: "GET_CODE",
  ClEAR_ANSWER: "ClEAR_ANSWER",
  APPRECIATION_MESSAGE: "APPRECIATION_MESSAGE",
  GET_QUESTION_RESULT: "GET_QUESTION_RESULT",
};

export default QuestionType;
